import React, { useEffect, useState } from 'react';
import Footer from '../components/footer';
import ScrollTopWrapper from '../components/scrollToTopWrapper';
import DistNav from './navigation';
import Topbar from '../components/header/topbar';
import LogoSearch from '../components/header/LogoSearch';
import { fetchBranchBySlug } from '../../services/branchs.service';
import Branch from '../../models/branch.model';
import { useParams } from 'react-router';
import Preloader from '../../components/PreLoader';

interface params{
  dist_slug:string
}



const ProvinceLayout:React.FC = props =>{

  const {children} = props;
  const {dist_slug} = useParams<params>();
  const [branch,setBranch] = useState<Branch|undefined>(undefined);
  const [loading,setLoading] = useState<boolean>(false);

  const init = async()=>{
    setLoading(true)
    const branch = await fetchBranchBySlug(dist_slug);
    setBranch(branch);
    setLoading(false)
  }
  useEffect(()=>{
    init();
  },[dist_slug]); //eslint-disable-line

  return(
    <ScrollTopWrapper>
      {loading?<Preloader/>:
        <>
          <header className="ecn-header">
            <Topbar/>
            {
              branch?
              <>
              <LogoSearch branch={branch}/>
              <DistNav branch={branch}/>
              </>:''
            }
            
          </header>
          <div style={{minHeight:'70vh'}}>
          {children}
          </div>
          <Footer branch={branch}/>
        </>
      }
    </ScrollTopWrapper>
  );
}

export default ProvinceLayout;